// extracted by mini-css-extract-plugin
export default {"cta":"ZF-z","disabled":"_F-z"};